var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 134.373,
    viewBox: "0 0 150 134.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "attachment",
    d: "M135.776,91.668,81.086,146.7a4.651,4.651,0,1,1-6.565-6.591l64.1-64.5a6.751,6.751,0,0,1,9.623,0l14.439,14.532a6.888,6.888,0,0,1,0,9.688l-64.1,64.5a29.3,29.3,0,0,1-41.564,0,29.743,29.743,0,0,1,0-41.846l54.69-55.033a7.791,7.791,0,0,0,0-11,7.712,7.712,0,0,0-10.937,0l-54.69,55.033a45.379,45.379,0,0,0,0,63.846,44.663,44.663,0,0,0,63.439,0l68.909-69.345a15.67,15.67,0,0,0,0-22.031L154.369,59.761a15.372,15.372,0,0,0-21.876,0L63.584,129.109a20.314,20.314,0,0,0,0,28.593,20.016,20.016,0,0,0,28.441,0l54.69-55.034a7.757,7.757,0,0,0-10.939-11Z",
    transform: "translate(-32.957 -54.174)",
    fill: "#674188",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.20a3ef53832a1af506b85d8762d65cf3.svg";
export { ForwardRef as ReactComponent };